import React, { useEffect } from 'react';
import '../styles/indian-card-betting.css';

const IndianCardGamesBettingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;

  return (
    <div className="indian-card-betting-page">
      <section className="indian-card-betting-intro">
        <div className="indian-card-betting-intro-content">
          <h1><span>Mahadev Indian Card Games:</span> Dive Into a World of Classic Desi Thrill</h1>
          <p>
            Welcome to Mahadev Indian Card Games – your one-stop destination to experience the nostalgic charm of traditional Indian card games blended with modern excitement. From timeless favorites to fast-paced new formats, our platform is crafted to thrill every kind of player.
          </p>
          <div className="indian-card-betting-cta-buttons">
            <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
              Open Your Demo Account
            </a>
            <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
              Contact Us Now
            </a>
          </div>
        </div>

        <div className="indian-card-betting-intro-image">
          <img src="/indian-card-games.webp" alt="Indian Card Games Betting" className="tennis-image" />
        </div>
      </section>

      <section className="indian-card-betting-features">
        <h2><span>Mahadev</span>: Your Hub for Iconic Indian Card Games</h2>
        <p>
          Explore an exciting mix of India's most-loved card games—Teen Patti, Andar Bahar, 7Up 7Down, 32 Cards, Hi-Low, Matka, Queen Race, Poker, and more. Whether you're playing casually or chasing high-stakes thrills, Mahadev offers the perfect table for you.
        </p>
        <ul>
          <li>
            <strong>Live Table Action:</strong> Enjoy real-time games with real opponents. Our live casino environment brings authentic Indian gaming straight to your screen.
          </li>
          <li>
            <strong>User-Friendly Interface:</strong> Whether you're a first-time player or a seasoned pro, our platform is designed for easy navigation, smooth gameplay, and quick access to all your favorite games.
          </li>
        </ul>
        <div className="indian-card-betting-cta-buttons">
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Open Your Demo Account
          </a>
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Contact Us Now
          </a>
        </div>
      </section>

      <section className="indian-card-betting-getting-started">
        <h2><span>Mahadev</span>: Safe, Private, and Responsible</h2>
        <p>
          We prioritize your privacy and peace of mind. Mahadev uses cutting-edge encryption to keep your data and transactions secure at all times.
        </p>
        <p>
          Gaming should always be fun. That's why we promote responsible play—set your limits, track your activity, and play smart with our helpful in-app features.
        </p>
      </section>

      <section className="indian-card-betting-join">
        <h2>Join <span>Mahadev Indian Card Games</span> Today!</h2>
        <p>
          Ready to experience the rush of traditional Indian card gaming with a modern twist? Mahadev gives you access to a wide variety of games, expert support, seamless gameplay, and the thrill of live competition. Join now and feel the difference!
        </p>
        <div className="tennis-betting-cta-buttons">
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Open Your Demo Account
          </a>
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Contact Us Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default IndianCardGamesBettingPage;
